export default __webpack_public_path__ + "static/media/cvod-13.9713e7d1.svg";